(function () {
  var CONFIG = window.__TRACK_CONFIG__ || {};
  var PROGRESS_STEPS = [
    { key: 'ready', label: 'Order Ready' },
    { key: 'transit', label: 'In Transit' },
    { key: 'out', label: 'Out for Delivery' },
    { key: 'delivered', label: 'Delivered' },
  ];

  var TRUCK_SVG =
    '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false" fill="currentColor"><path d="M17.816 14c-.415-1.162-1.514-2-2.816-2s-2.4.838-2.816 2H12v-4h6v4h-.184zM15 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM5 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM2 4h8v10H7.816C7.4 12.838 6.302 12 5 12s-2.4.838-2.816 2H2V4zm13.434 1l1.8 3H12V5h3.434zm4.424 3.485l-3-5C16.678 3.185 16.35 3 16 3h-4a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h1.185C2.6 17.162 3.698 18 5 18s2.4-.838 2.816-2h4.37c.413 1.162 1.512 2 2.814 2s2.4-.838 2.816-2H19a1 1 0 0 0 1-1V9c0-.18-.05-.36-.142-.515z"/></svg>';

  var STATUS_LABELS = {
    INIT: 'Pending',
    NO_RECORD: 'No tracking info yet',
    INFO_RECEIVED: 'Information received',
    IN_TRANSIT: 'In transit',
    WAITING_DELIVERY: 'Out for delivery',
    DELIVERY_FAILED: 'Delivery failed',
    ABNORMAL: 'Shipment exception',
    DELIVERED: 'Delivered',
    EXPIRED: 'Tracking expired',
  };

  var STEP_SVGS = {
    ready:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="currentColor"><path d="M19 7h-1V6a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v1H5a1 1 0 0 0-1 1v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 0 0-1-1zM9 6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1H9V6zm8 13a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-5h10v5z"/></svg>',
    transit: TRUCK_SVG,
    out:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="currentColor"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z"/></svg>',
    delivered:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="currentColor"><path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>',
  };

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function copyIconSvg() {
    return (
      '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>' +
      '<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>' +
      '</svg>'
    );
  }

  function checkIconSvg() {
    return (
      '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
      '<polyline points="20 6 9 17 4 12"></polyline>' +
      '</svg>'
    );
  }

  function externalLinkIconSvg() {
    return (
      '<svg class="track-link-card__action-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M14 5h5v5"></path>' +
      '<path d="M10 14 19 5"></path>' +
      '<path d="M19 13v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"></path>' +
      '</svg>'
    );
  }

  function statusIconSvg() {
    return (
      '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="currentColor">' +
      '<path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4z"/>' +
      '</svg>'
    );
  }

  function formatDisplayDate(value) {
    var raw = String(value || '').trim();
    if (!raw) return '—';
    var ts = Date.parse(raw);
    if (Number.isNaN(ts)) return raw;
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).format(new Date(ts));
  }

  function smallCheckSvg() {
    return (
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="currentColor">' +
      '<path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>' +
      '</svg>'
    );
  }

  function smallTruckSvg() {
    return TRUCK_SVG;
  }

  function getConfigMessage(key, fallback) {
    return CONFIG[key] || fallback;
  }

  function normalizeTrackNumber(value) {
    return String(value || '')
      .trim()
      .replace(/\s+/g, '');
  }

  function isValidTrackNumber(value) {
    return /^[A-Za-z0-9+\-_.\s]{4,64}$/.test(value);
  }

  function normalizeEmail(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function getShipmentsPayload(data) {
    if (!data) return null;
    if (Array.isArray(data.shipments) && data.shipments.length) return data.shipments;
    if (data.data && Array.isArray(data.data.shipments) && data.data.shipments.length) {
      return data.data.shipments;
    }
    return null;
  }

  function getShipmentTrackNo(shipment) {
    return shipment && shipment.trackNo ? String(shipment.trackNo) : 'Package';
  }

  function buildPackageSelectorHtml(shipments, orderName) {
    return (
      '<div class="track-package-selector" data-track-package-selector>' +
      '<div class="track-package-selector__header">' +
      '<h2 class="track-package-selector__title">Select a package</h2>' +
      (orderName
        ? '<p class="track-package-selector__subtitle">Order ' + escapeHtml(orderName) + '</p>'
        : '') +
      '</div>' +
      '<div class="track-package-selector__list" role="tablist" aria-label="Shipment packages">' +
      shipments
        .map(function (shipment, index) {
          var trackNo = getShipmentTrackNo(shipment);
          return (
            '<button type="button" class="track-package-selector__item' +
            (index === 0 ? ' is-active' : '') +
            '" data-track-package-index="' +
            index +
            '" role="tab" aria-selected="' +
            (index === 0 ? 'true' : 'false') +
            '">' +
            '<span class="track-package-selector__label">Package ' +
            (index + 1) +
            '</span>' +
            '<span class="track-package-selector__track">' +
            escapeHtml(trackNo) +
            '</span>' +
            '</button>'
          );
        })
        .join('') +
      '</div>' +
      '<div class="track-package-selector__panel" data-track-package-panel></div>' +
      '</div>'
    );
  }

  function bindPackageSelector(container, shipments) {
    var selector = container.querySelector('[data-track-package-selector]');
    if (!selector || !shipments.length) return;

    var panel = selector.querySelector('[data-track-package-panel]');
    var buttons = selector.querySelectorAll('[data-track-package-index]');

    function renderPackage(index) {
      if (!panel || !shipments[index]) return;
      panel.innerHTML = buildResultsHtml(shipments[index]);
      bindCopyButtons(panel);
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = Number(button.getAttribute('data-track-package-index') || '0');
        buttons.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');
        renderPackage(index);
      });
    });

    renderPackage(0);
  }

  function renderPackageResults(container, shipments, orderName) {
    container.innerHTML = buildPackageSelectorHtml(shipments, orderName);
    container.hidden = false;
    bindPackageSelector(container, shipments);
  }

  function getAcceptedPayload(data) {
    if (!data) return null;
    if (data.accepted) return data.accepted;
    if (data.data && data.data.accepted) return data.data.accepted;
    return null;
  }

  function getRejectedPayload(data) {
    if (!data) return null;
    if (data.rejected) return data.rejected;
    if (data.data && data.data.rejected) return data.data.rejected;
    return null;
  }

  function getProgressIndex(status) {
    var normalized = String(status || '').toUpperCase();
    if (normalized === 'DELIVERED') return 3;
    if (normalized === 'WAITING_DELIVERY') return 2;
    if (normalized === 'IN_TRANSIT') return 1;
    return 0;
  }

  function formatStatusLabel(status) {
    return STATUS_LABELS[String(status || '').toUpperCase()] || status || 'Unknown';
  }

  function parseEventDate(text) {
    var ts = Date.parse(String(text || '').trim());
    return Number.isNaN(ts) ? NaN : ts;
  }

  function getTimelineEvents(details) {
    return (details || [])
      .map(function (item) {
        return {
          ts: parseEventDate(item.eventTime),
          timeText: item.eventTime || '',
          bodyText: String(item.eventDetail || '').toLowerCase(),
        };
      })
      .filter(function (event) {
        return !Number.isNaN(event.ts);
      });
  }

  function findEarliestMatch(events, patterns) {
    var matches = events.filter(function (event) {
      return patterns.some(function (pattern) {
        return pattern.test(event.bodyText);
      });
    });
    if (!matches.length) return null;
    return matches.reduce(function (earliest, event) {
      return event.ts < earliest.ts ? event : earliest;
    });
  }

  function findLatestMatch(events, patterns) {
    var matches = events.filter(function (event) {
      return patterns.some(function (pattern) {
        return pattern.test(event.bodyText);
      });
    });
    if (!matches.length) return null;
    return matches.reduce(function (latest, event) {
      return event.ts > latest.ts ? event : latest;
    });
  }

  var TRANSIT_PATTERNS = [
    /picked up/,
    /in transit/,
    /departed/,
    /arrived at/,
    /flight/,
    /airport/,
    /customs/,
    /clearance/,
    /facility/,
  ];

  function getStepDate(stepKey, events, shipment) {
    if (stepKey === 'ready') {
      var ready = findEarliestMatch(events, [/information received/, /order ready/, /ready to ship/, /picked up/]);
      return ready ? ready.timeText : shipment.receiptTime || '';
    }
    if (stepKey === 'transit') {
      var transit = findLatestMatch(events, TRANSIT_PATTERNS);
      return transit ? transit.timeText : shipment.receiptTime || '';
    }
    if (stepKey === 'out') {
      var out = findLatestMatch(events, [/out for delivery/]);
      return out ? out.timeText : '';
    }
    if (stepKey === 'delivered') {
      return shipment.deliveredTime || '';
    }
    return '';
  }

  function buildProgressHtml(activeIndex, events, shipment) {
    var lineRatio = PROGRESS_STEPS.length > 1 ? activeIndex / (PROGRESS_STEPS.length - 1) : 0;
    var iconHtml = '';
    var textHtml = '';
    var mirrorHtml = '';

    PROGRESS_STEPS.forEach(function (step, index) {
      var state = 'is-pending';
      if (index <= activeIndex) {
        state = 'is-complete' + (index === activeIndex ? ' is-current' : '');
      }

      var dateText = getStepDate(step.key, events, shipment);
      if (!dateText && state === 'is-pending') dateText = '—';

      var iconWrap =
        '<span class="track-step-icon ' +
        state +
        '">' +
        STEP_SVGS[step.key] +
        '</span>';

      var textBox =
        '<div class="track_progress_text_box ' +
        state +
        '">' +
        '<div class="track_progress_title">' +
        escapeHtml(step.label) +
        '</div>' +
        '<div class="track_progress_date">' +
        escapeHtml(formatDisplayDate(dateText)) +
        '</div>' +
        '</div>';

      iconHtml += iconWrap;
      textHtml += textBox;
      mirrorHtml +=
        '<div class="track-progress-step">' + iconWrap + textBox + '</div>';
    });

    return (
      '<div class="track_progress track-status-card__progress">' +
      '<div class="track_progress_icon" style="--track-line-ratio:' +
      lineRatio +
      '">' +
      iconHtml +
      '</div>' +
      '<div class="track_progress_text">' +
      textHtml +
      '</div>' +
      '<div class="track-progress-steps track-progress-steps--mirror" aria-hidden="true">' +
      mirrorHtml +
      '</div>' +
      '</div>'
    );
  }

  function getTimelineAvatarHtml(item, index, transitStatus) {
    var detail = String(item.eventDetail || '');
    var isDelivered =
      index === 0 && String(transitStatus || '').toUpperCase() === 'DELIVERED';

    if (isDelivered) {
      return (
        '<span class="semi-avatar semi-avatar-img semi-avatar--delivered" aria-hidden="true">' +
        smallCheckSvg() +
        '</span>'
      );
    }

    if (/out for delivery/i.test(detail)) {
      return (
        '<span class="semi-avatar semi-avatar-img semi-avatar--out-for-delivery" aria-hidden="true">' +
        smallTruckSvg() +
        '</span>'
      );
    }

    if (index === 0) {
      return '<span class="semi-avatar semi-avatar-img"></span>';
    }

    return '<span class="semi-avatar semi-avatar-grey"></span>';
  }

  function buildTimelineHtml(details, transitStatus) {
    if (!details || !details.length) {
      return '<p class="track-empty">No shipment events yet.</p>';
    }

    return (
      '<ul class="semi-timeline semi-timeline-left">' +
      details
        .map(function (item, index) {
          return (
            '<li class="semi-timeline-item' +
            (index === 0 ? ' is-current' : '') +
            '">' +
            '<div class="semi-timeline-item-head">' +
            getTimelineAvatarHtml(item, index, transitStatus) +
            '</div>' +
            '<div class="semi-timeline-item-tail"></div>' +
            '<div class="semi-timeline-item-content">' +
            '<div class="map_info_mock">' +
            (index === 0
              ? '<span class="track-event-badge">Current Status</span>'
              : '') +
            '<div class="map_info_mock_item">' +
            escapeHtml(formatDisplayDate(item.eventTime || '')) +
            (item.address ? ' · ' + escapeHtml(item.address) : '') +
            '</div>' +
            '<div class="map_info_mock_item">' +
            escapeHtml(item.eventDetail || '') +
            '</div>' +
            '</div>' +
            '</div>' +
            '</li>'
          );
        })
        .join('') +
      '</ul>'
    );
  }

  function buildDetailItem(label, value) {
    if (!value) return '';
    return (
      '<div class="track_map_detail_item">' +
      '<div class="track_map_detail_item_title">' +
      escapeHtml(label) +
      '</div>' +
      '<div class="track_map_detail_item_text">' +
      escapeHtml(value) +
      '</div>' +
      '</div>'
    );
  }

  function buildDetailsCard(shipment) {
    var logistics = shipment.localLogisticsInfo || {};
    var trackNo = shipment.trackNo || '';
    var items =
      buildDetailItem('Carrier', logistics.courierNameEN || logistics.courierCode) +
      buildDetailItem('Tracking Number', trackNo) +
      buildDetailItem('Ship from', shipment.shipFrom) +
      buildDetailItem('Ship to', shipment.shipTo);

    var linkHtml = '';
    if (logistics.courierTrackingLink) {
      var link = String(logistics.courierTrackingLink).replace(
        '#{trackingNo}',
        encodeURIComponent(shipment.trackNo || '')
      );
      linkHtml =
        '<p class="track-details__link-wrap">' +
        '<a class="track-details__link" href="' +
        escapeHtml(link) +
        '" target="_blank" rel="noopener noreferrer">View on carrier website</a>' +
        '</p>';
    }

    return (
      '<div class="semi-card semi-card-bordered">' +
      '<div class="semi-card-header track-side-card-header">' +
      '<h3 class="track-side-card-title">Shipment Details</h3>' +
      '</div>' +
      '<div class="semi-card-body">' +
      items +
      linkHtml +
      '</div>' +
      '</div>'
    );
  }

  function buildStatusBanner(status, shipment) {
    var label = formatStatusLabel(status);
    var detail = shipment.lastTrackingTime
      ? 'Last updated ' + shipment.lastTrackingTime
      : 'Tracking updates from your carrier';

    return (
      '<div class="track-status-banner">' +
      '<div class="track-status-banner__left">' +
      '<span class="track-status-banner__icon" aria-hidden="true">' +
      statusIconSvg() +
      '</span>' +
      '<div>' +
      '<span class="track-status-banner__title">' +
      escapeHtml(label) +
      '</span>' +
      '<p class="track-status-banner__text">' +
      escapeHtml(detail) +
      '</p>' +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  function buildResultsHtml(shipment) {
    var status = shipment.transitStatus || '';
    var activeIndex = getProgressIndex(status);
    var trackNo = shipment.trackNo || '';
    var logistics = shipment.localLogisticsInfo || {};
    var details = logistics.trackingDetails || [];
    var events = getTimelineEvents(details);

    return (
      '<div class="track-order-row track-status-card__order">' +
      '<span class="track-order-row__id">Shipment tracking</span>' +
      '<div class="track-order-row__meta">' +
      '<span class="track-order-row__meta-label">Tracking Number:</span>' +
      '<span class="track-order-row__meta-value">' +
      escapeHtml(trackNo) +
      '</span>' +
      '<button type="button" class="track-order-row__copy" data-track-copy="' +
      escapeHtml(trackNo) +
      '" aria-label="Copy tracking number">' +
      copyIconSvg() +
      '</button>' +
      '</div>' +
      '</div>' +
      buildProgressHtml(activeIndex, events, shipment) +
      '<div class="track_map_info_block">' +
      '<div class="semi-card semi-card-bordered">' +
      '<div class="semi-card-header track-side-card-header">' +
      '<h3 class="track-side-card-title">Shipment Activity</h3>' +
      '</div>' +
      '<div class="semi-card-body">' +
      buildTimelineHtml(details, status) +
      '</div>' +
      '</div>' +
      '<div class="track_info_right">' +
      buildDetailsCard(shipment) +
      '</div>' +
      '</div>'
    );
  }

  function alertIconSvg() {
    return (
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="12" cy="12" r="10"></circle>' +
      '<line x1="12" y1="8" x2="12" y2="12"></line>' +
      '<line x1="12" y1="16" x2="12.01" y2="16"></line>' +
      '</svg>'
    );
  }

  function buildMessageHtml(message) {
    return (
      '<div class="track-order-alert" role="status">' +
      '<span class="track-order-alert__icon" aria-hidden="true">' +
      alertIconSvg() +
      '</span>' +
      '<p class="track-order-alert__text">' +
      escapeHtml(message) +
      '</p>' +
      '</div>'
    );
  }

  function setLoading(form, isLoading) {
    var submit = form.querySelector('[data-track-submit]');
    var spinner = form.querySelector('[data-track-spinner]');
    var inputs = form.querySelectorAll('.track-order__input');

    if (submit) submit.disabled = isLoading;
    inputs.forEach(function (input) {
      input.disabled = isLoading;
    });
    if (spinner) spinner.hidden = !isLoading;
  }

  function getActiveMode(form) {
    var activeTab = form.querySelector('[data-track-mode-tab].is-active');
    return (activeTab && activeTab.getAttribute('data-track-mode-tab')) || 'trackingNumber';
  }

  function setActiveMode(form, mode) {
    var tabs = form.querySelectorAll('[data-track-mode-tab]');
    var panels = form.querySelectorAll('[data-track-panel]');

    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-track-mode-tab') === mode;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-track-panel') === mode;
      panel.hidden = !isActive;
    });
  }

  function clearResults(container) {
    if (!container) return;
    container.innerHTML = '';
    container.hidden = true;
  }

  function bindModeTabs(form, resultsEl, hintEl) {
    form.querySelectorAll('[data-track-mode-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActiveMode(form, tab.getAttribute('data-track-mode-tab') || 'trackingNumber');
        if (hintEl) hintEl.textContent = '';
        clearResults(resultsEl);
      });
    });
  }

  function bindResultsResetOnInput(form, resultsEl, hintEl) {
    form.querySelectorAll('.track-order__input').forEach(function (input) {
      input.addEventListener('input', function () {
        if (!String(input.value || '').trim()) {
          clearResults(resultsEl);
          if (hintEl) hintEl.textContent = '';
        }
      });
    });
  }

  function buildLookupPayload(form) {
    var mode = getActiveMode(form);

    if (mode === 'email') {
      var emailInput = form.querySelector('.track-order__input--email');
      var orderNumberInput = form.querySelector('.track-order__input--order-number');
      var email = normalizeEmail(emailInput && emailInput.value);
      var orderNumber = String((orderNumberInput && orderNumberInput.value) || '').trim();
      if (!email || !isValidEmail(email)) {
        return { error: 'Please enter the email used at checkout.', focus: emailInput };
      }
      if (!orderNumber) {
        return { error: 'Please enter your order number.', focus: orderNumberInput };
      }
      return { payload: { email: email, orderNumber: orderNumber } };
    }

    var trackingInput = form.querySelector('.track-order__input--tracking');
    var trackingNumber = normalizeTrackNumber(trackingInput && trackingInput.value);
    if (!trackingNumber) {
      return { error: 'Please enter your tracking number.', focus: trackingInput };
    }
    if (!isValidTrackNumber(trackingNumber)) {
      return { error: 'Please enter a valid tracking number.', focus: trackingInput };
    }
    return { payload: { trackingNumber: trackingNumber } };
  }

  function bindCopyButtons(container) {
    container.querySelectorAll('[data-track-copy]').forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.getAttribute('data-track-copy') || '';
        if (!value || !navigator.clipboard) return;

        var originalHtml = button.innerHTML;
        var originalLabel = button.getAttribute('aria-label');

        navigator.clipboard.writeText(value).then(function () {
          button.innerHTML = checkIconSvg();
          button.classList.add('track-order-row__copy--copied');
          button.setAttribute('aria-label', 'Copied');

          window.setTimeout(function () {
            button.innerHTML = originalHtml;
            button.classList.remove('track-order-row__copy--copied');
            button.setAttribute('aria-label', originalLabel);
          }, 2000);
        });
      });
    });
  }

  function renderResults(container, html) {
    container.innerHTML = html;
    container.hidden = false;
    bindCopyButtons(container);
  }

  function getTrackingPackages(payload) {
    if (!payload) return [];
    if (payload.data && Array.isArray(payload.data.packages)) return payload.data.packages;
    if (Array.isArray(payload.packages)) return payload.packages;
    return [];
  }

  function formatCarrierName(value) {
    var carrier = String(value || '').trim();
    var normalized = carrier.toUpperCase();
    if (normalized === 'USPS') return 'USPS';
    if (normalized === 'UPS') return 'UPS';
    if (normalized === 'FEDEX') return 'FedEx';
    if (normalized.indexOf('DHL') === 0) return 'DHL';
    if (normalized === 'YUNEXPRESS' || normalized === 'YUN_EXPRESS') return 'YunExpress';
    if (normalized === '4PX') return '4PX';
    if (normalized === 'SF_EXPRESS' || normalized === 'SFEXPRESS') return 'SF Express';
    if (normalized === 'AMAZON_SHIPPING' || normalized === 'AMAZON' || normalized === 'AMAZON_SHIPPING_TBA') return 'Amazon Shipping';

    // Fallback: replace underscores/hyphens with spaces and capitalize words
    var cleaned = carrier.replace(/[_-]+/g, ' ');
    return (
      cleaned.replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      }) || 'Shipping carrier'
    );
  }

  function buildTrackingLinksHtml(packages, orderName) {
    return (
      '<div class="track-link-results">' +
      '<header class="track-link-results__header">' +
      '<span class="track-link-results__eyebrow">Tracking details</span>' +
      '<h2 class="track-link-results__title">' +
      (orderName ? 'Order ' + escapeHtml(orderName) : 'Your packages') +
      '</h2>' +
      '<p class="track-link-results__description">Select a package to view the latest updates on the carrier website.</p>' +
      '</header>' +
      '<div class="track-link-results__list">' +
      packages
        .map(function (item, index) {
          var carrier = formatCarrierName(item.carrier);
          var actionLabel = carrier === 'Shipping carrier' ? 'View tracking' : 'Track on ' + carrier;
          return (
            '<article class="track-link-card">' +
            '<span class="track-link-card__index" aria-hidden="true">' +
            String(index + 1).padStart(2, '0') +
            '</span>' +
            '<div class="track-link-card__content">' +
            '<div class="track-link-card__heading">' +
            '<span class="track-link-card__package">Package ' + (index + 1) + '</span>' +
            '<strong class="track-link-card__carrier">' + escapeHtml(carrier) + '</strong>' +
            '</div>' +
            '<span class="track-link-card__number-label">Tracking number</span>' +
            '<div class="track-link-card__number-row">' +
            '<code class="track-link-card__number">' + escapeHtml(item.trackingNumber) + '</code>' +
            '<button class="track-link-card__copy" type="button" data-track-copy="' +
            escapeHtml(item.trackingNumber) +
            '" aria-label="Copy tracking number">' +
            copyIconSvg() +
            '</button>' +
            '</div>' +
            '</div>' +
            '<div class="track-link-card__actions">' +
            '<a class="semi-button semi-button-primary track-link-card__action" href="' +
            escapeHtml(item.trackingUrl) +
            '" target="_blank" rel="noopener noreferrer"><span class="track-link-card__action-label">' +
            escapeHtml(actionLabel) +
            '</span>' +
            externalLinkIconSvg() +
            '</a>' +
            '<span class="track-link-card__action-note">Opens carrier website</span>' +
            '</div>' +
            '</article>'
          );
        })
        .join('') +
      '</div>' +
      '</div>'
    );
  }

  function getProxyUrl() {
    var configured = String(CONFIG.proxyUrl || '').trim();
    try {
      var hostname = window.location && window.location.hostname;
      if (hostname === '127.0.0.1' || hostname === 'localhost') {
        return 'http://127.0.0.1:8787/track';
      }
    } catch (_error) {
      // ignore
    }
    return configured;
  }

  async function lookupTracking(payload) {
    var proxyUrl = getProxyUrl();
    if (!proxyUrl || proxyUrl.indexOf('YOUR_SUBDOMAIN') !== -1) {
      throw new Error(getConfigMessage('configureMessage', 'Tracking proxy is not configured.'));
    }

    var response = await fetch(proxyUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    var payload;
    try {
      payload = await response.json();
    } catch (_error) {
      throw new Error(getConfigMessage('errorMessage', 'Unable to read tracking response.'));
    }

    if (!response.ok && (!payload || !payload.code)) {
      throw new Error(getConfigMessage('errorMessage', 'Tracking lookup failed.'));
    }

    return payload;
  }

  function handleLookupResponse(payload, resultsEl) {
    if (payload.code && payload.code !== '00000') {
      renderResults(
        resultsEl,
        buildMessageHtml(
          payload.msg ||
            getConfigMessage('notFoundMessage', 'We could not find tracking information for that order yet.')
        )
      );
      return;
    }

    var packages = getTrackingPackages(payload);
    if (packages.length) {
      renderResults(
        resultsEl,
        buildTrackingLinksHtml(packages, payload.data && payload.data.orderName)
      );
      return;
    }

    var shipments = getShipmentsPayload(payload.data || payload);
    if (shipments && shipments.length > 1) {
      var orderName =
        (payload.data && payload.data.orderName) || (payload.orderName ? payload.orderName : '');
      renderPackageResults(resultsEl, shipments, orderName);
      return;
    }

    if (shipments && shipments.length === 1) {
      renderResults(resultsEl, buildResultsHtml(shipments[0]));
      return;
    }

    var accepted = getAcceptedPayload(payload);
    if (accepted) {
      renderResults(resultsEl, buildResultsHtml(accepted));
      return;
    }

    var rejected = getRejectedPayload(payload);
    if (rejected) {
      renderResults(
        resultsEl,
        buildMessageHtml(
          rejected.errorMsg ||
            rejected.msg ||
            getConfigMessage('notFoundMessage', 'Tracking not found.')
        )
      );
      return;
    }

    renderResults(
      resultsEl,
      buildMessageHtml(getConfigMessage('notFoundMessage', 'Tracking not found.'))
    );
  }

  function initSection(section) {
    var form = section.querySelector('[data-track-form]');
    var resultsEl = section.querySelector('[data-track-results]');
    var hintEl = section.querySelector('[data-track-hint]');

    if (!form || !resultsEl) return;

    bindModeTabs(form, resultsEl, hintEl);
    bindResultsResetOnInput(form, resultsEl, hintEl);

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      var lookup = buildLookupPayload(form);
      if (lookup.error) {
        if (hintEl) hintEl.textContent = lookup.error;
        lookup.focus && lookup.focus.focus();
        return;
      }

      if (hintEl) hintEl.textContent = '';
      setLoading(form, true);
      clearResults(resultsEl);

      try {
        var payload = await lookupTracking(lookup.payload);
        handleLookupResponse(payload, resultsEl);
      } catch (error) {
        renderResults(
          resultsEl,
          buildMessageHtml(
            error.message || getConfigMessage('errorMessage', 'Tracking lookup failed.')
          )
        );
      } finally {
        setLoading(form, false);
      }
    });

    var params = new URLSearchParams(window.location.search);
    var prefilledTracking = normalizeTrackNumber(
      params.get('tracking') || params.get('trackingNumber') || params.get('track') || ''
    );

    if (prefilledTracking) {
      setActiveMode(form, 'trackingNumber');
      var trackingEl = form.querySelector('.track-order__input--tracking');
      if (trackingEl) trackingEl.value = prefilledTracking;
      form.requestSubmit();
    }
  }

  function init() {
    document.querySelectorAll('.track-order-section').forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
